angular.module("contractSelectedAddressInfo.components", []).component("contractSelectedAddressInfo", {
    templateUrl: "ng/components/changeGoodAddress/contractSelectedAddressInfo/contractSelectedAddressInfo.view.html",
    bindings: {
        contractSelected: "<",
        dettaglioSelected: "&",
        searchLoader: '<',
        varIndirizzo: "<",
        isCessioneVoltura: "=",
        richiestaPv: '<',
        enableDisabledCheck: '<',
        riscattoAnticipato: '<',
        isRiscattoTermine: '<'
    },
    controllerAs: "contractAddressInfoCtrl",
    controller: ContractAddressInfoCtrl
});

function ContractAddressInfoCtrl(
    $timeout
) {
    var self = this;

    self.supportModel = {
        selectDeselectAll: {
            selected: false,
            showVarIndirizzi: false
        },
        isTargato: false
    }

    self.$onInit = function () {
        self.resumedPractice = true;
        self.oneElementSelected = true;
        if ((self.richiestaPv && self.richiestaPv.metadata && self.richiestaPv.metadata.riscattoAnticipato && self.richiestaPv.metadata.riscattoAnticipato.prodottoTargato) ||
            (self.richiestaPv && self.richiestaPv.metadata && self.richiestaPv.metadata.riscattoATermine && self.richiestaPv.metadata.riscattoATermine.prodottoTargato)) {
            self.supportModel.isTargato = true;
        }
        self.exportContracts();
        $timeout(function () {
            checkForShowMessage();
        }, 200)
        if (self.isRiscattoTermine) {
            self.contractSelected = self.contractSelected.map(x => {

                Object.assign(x, {
                    numero: x.numeroContratto,
                    modulo: x.numeroModulo
                })
                return x;
            })
        }
    };

    self.$onChanges = function (changed) {
        if (self.supportModel && changed.varIndirizzo &&
            typeof changed.varIndirizzo.currentValue != "undefined") {
            self.supportModel.showVarIndirizzi = changed.varIndirizzo.currentValue;
        }
        if (changed.enableDisabledCheck && changed.enableDisabledCheck.currentValue != "undefined" && self.resumedPractice) {
            self.enableDisabledCheck = changed.enableDisabledCheck.currentValue
            self.supportModel.selectDeselectAll.selected = self.enableDisabledCheck
            self.selectedDeselectedAll(self.supportModel.selectDeselectAll, true)


        }
    }

    self.onCheckboxChange = function (el) {
        el.selected = !el.selected;
        self.exportContracts();

        checkForShowMessage();
    }

    self.selectedDeselectedAll = function (element, fromInputChange) {
        if (!fromInputChange) {
            element.selected = !element.selected;
        }
        self.contractSelected.forEach(function (dettaglio) {
            dettaglio.selected = element.selected;
        })
        checkForShowMessage();
        self.exportContracts();
    }

    self.exportContracts = function () {
        self.dettaglioSelected({
            dettaglio: self.contractSelected
        })
    }

    var checkForShowMessage = function () {
        self.oneElementSelected = self.contractSelected.some(x => { return x.selected == true })
    }
}